import React, {SyntheticEvent, Component} from 'react';
import FilterGroup from '../FilterGroup/FilterGroup';
import {FilterGroupExpandable} from '../FilterGroupExpandable/FilterGroupExpandable';
import {displayFilterGroup, filterGroupFilters} from '../../utils/filters';
import type {Refinement, RefinementTooltip} from '../FilterGroup/FilterGroup';

import './MoreFilters.less';

export type FilterGroupInfo = {
    id: string;
    name: string;
};

export type FilterGroupType = {
    groupInfo: FilterGroupInfo;
    filters: Refinement[];
};

export type Props = {
    filterGroups: FilterGroupType[];
    handleChecked: (event: SyntheticEvent<HTMLInputElement>) => void;
    numLines?: number;
    checked: string[];
    className?: string;
    tooltipOptions: RefinementTooltip;
};

const anyChecked = (
    searchFilters: Refinement[],
    checked: string[]
): boolean => {
    for (let i = 0; i < searchFilters.length; i++) {
        if (checked.includes(searchFilters[i].filter.refineByQueryArgument)) {
            return true;
        }
    }
    return false;
};

type State = {
    filterChecked: string[];
};

export const renderFilterGroups = (
    filterChecked: string[],
    {
        filterGroups,
        className,
        handleChecked,
        checked,
        numLines = 6,
        tooltipOptions,
    }: Props
) => {
    return filterGroups.map((filterGroup) => {
        const groupFilters = filterGroupFilters(filterGroup);
        const filterGroupId = filterGroup.groupInfo.id;
        return (
            <div
                className={className}
                key={filterGroupId}
                data-wdio={`MoreFilterGroup_${filterGroupId}`}
                role="menuitem"
            >
                {displayFilterGroup(filterGroup) &&
                    groupFilters.length > numLines && (
                        <div
                            className="MoreFilters__filter-group"
                            data-wdio={`MoreorLess_${filterGroupId}`}
                        >
                            <FilterGroupExpandable
                                handleChecked={handleChecked}
                                groupName={filterGroup.groupInfo.name}
                                filters={groupFilters}
                                checked={checked}
                                filterGroupId={filterGroupId}
                                expanded={anyChecked(
                                    groupFilters,
                                    filterChecked
                                )}
                                tooltipOptions={tooltipOptions}
                            />
                        </div>
                    )}

                {displayFilterGroup(filterGroup) &&
                    groupFilters.length <= numLines && (
                        <div className="MoreFilters__filter-group">
                            <FilterGroup
                                handleChecked={handleChecked}
                                groupName={filterGroup.groupInfo.name}
                                filterGroupId={filterGroupId}
                                filters={groupFilters}
                                checked={checked}
                                tooltipOptions={tooltipOptions}
                            />
                        </div>
                    )}
            </div>
        );
    });
};

export class MoreFilters extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            filterChecked: this.props.checked, // we only want to set this at initial mount
        };
    }

    render() {
        const {filterChecked} = this.state;
        return renderFilterGroups(filterChecked, this.props);
    }
}

export default MoreFilters;
